module.exports = __webpack_public_path__ + "/login_ui/img/gg-adb94c9a61c95ab503f71a9df6095798.svg";